import { AlertType, getIntegrationType, IntegrationType } from "@/app/constants/enums";
import { useUser } from "@/app/context/UserContext";
import { iProIntegration, iProProjectMain } from "@/app/models/interfaceProject";
import { Eye, EyeOff, Pencil, Undo2, X, Plus,Copy,Clipboard,ChevronDown, Palette } from "lucide-react"; 
import { maskText } from "@/app/helpers/functions";
import { useState } from "react";
import { chatbotProjectSecret } from "@/app/services/chatbotprojectsecret";
import { RequestChatBotProjectSecret } from "@/app/models/interfaceChatBotProjectSecret";
import Loading from "../Elements/Loading";
import { iWidgetChatConfig } from "@/app/models/interfaceChatWidget";
import ChatWidgetEditor from "../ChatWidget/ChatWidgetEditor";
import { getDefaultWidgetChatConfig } from "@/app/constants/defaultValue";
import Modal from "../Elements/Modal";


const IntegrationForm = () => {
  const {user, setUser, userProject, setUserProject, addAlert } = useUser();
  const integrations = userProject?.project?.chpro_integrations || []; 
  const [clonedIntegrationsAlt, setClonedIntegrationsAlt] = useState<iProIntegration[]>(JSON.parse(JSON.stringify(integrations)));
  const [visibility, setVisibility] = useState<{ [key: string]: boolean }>({});
  const [loadingVisibility, setLoadingVisibility] = useState<{ [key: string]: boolean }>({});
   
  const appTypes = [
    { value: "SingleTenant", text: "Único Inquilino" },
    { value: "MultiTenant", text: "Multi Inquilino" },
  ];

  const handleCopy = (text:string) => {
  navigator.clipboard.writeText(text);
  addAlert("Copiado",AlertType.Success,1000);
};

  const toggleVisibility = (type: string) => {
    setVisibility((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleToggleActive = (vIntegration: iProIntegration) => {
    const updatedIntegrations = userProject.project.chpro_integrations.map((integration) =>
      integration.type === vIntegration.type ? { 
        ...integration, active: !integration.active, 
        edit: !integration.edit,
        ...(integration.type === IntegrationType.Embed && !integration.active && !integration.key
            ? { key: crypto.randomUUID() }
            : {})
      } : integration
    );
  
    setUserProject({
      ...userProject,
      project: { 
        ...userProject.project, 
        chpro_integrations: updatedIntegrations,
        
      },
    });
    
  };

  const handleToggleEdit = (vIntegration: iProIntegration) => {
    const updatedIntegrations = userProject.project.chpro_integrations.map((integration) =>
        {
          if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Whatsapp){
            return{ ...integration, 
              edit: !integration.edit,
              account_id: "",
              graph_api_token: ""
            }
          } 
          if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Azure_bot){
            return{ ...integration, 
              edit: !integration.edit,
              account_id: "",
              app_id: "", 
              secret: ""
            }
          } 
          if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Supplier){
            return{ ...integration, 
              edit: !integration.edit,
              account_id: ""            
            }
          } 
          if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Embed){
            return{ ...integration, 
              edit: !integration.edit,
              key: crypto.randomUUID()          
            }
          } 
          return integration 
      } 
    );  
    setUserProject({
      ...userProject,
      project: { 
        ...userProject.project, 
        chpro_integrations: updatedIntegrations 
      },
    }); 
  };

  
  const handleInputChange = (vIntegration: iProIntegration, field: keyof iProIntegration, value: any) => {
    const updatedIntegrations = userProject.project.chpro_integrations.map((integration) =>
      integration.type === vIntegration.type ? { ...integration, [field]: value } : integration
    );

    setUserProject({
      ...userProject,
      project: {
        ...userProject.project,
        chpro_integrations: updatedIntegrations,
      },
    });
  };

  const handleAddDomain = (vIntegration: iProIntegration, domain: string) => {
  if (!domain.trim()) return;
  const currentDomains = vIntegration.domains || [];

  const updatedIntegrations = userProject.project.chpro_integrations.map((integration) =>
    integration.type === vIntegration.type
      ? {
          ...integration,
          domains: [...currentDomains, domain.trim()],
          edit: true // activar edit en el mismo cambio
        }
      : integration
  );

  setUserProject({
    ...userProject,
    project: {
      ...userProject.project,
      chpro_integrations: updatedIntegrations
    }
  });
};

const handleRemoveDomain = (vIntegration: iProIntegration, index: number) => {
  const currentDomains = vIntegration.domains || [];
  const updatedDomains = currentDomains.filter((_, i) => i !== index);

  const updatedIntegrations = userProject.project.chpro_integrations.map((integration) =>
    integration.type === vIntegration.type
      ? {
          ...integration,
          domains: updatedDomains,
          edit: true // activar edit en el mismo cambio
        }
      : integration
  );

  setUserProject({
    ...userProject,
    project: {
      ...userProject.project,
      chpro_integrations: updatedIntegrations
    }
  });
};


  const fetchToggleViev = async (vIntegration:iProIntegration)=>{ 
      
    if(!visibility[vIntegration.type]){
      try { 
          setLoadingVisibility((prev) => ({ ...prev, [vIntegration.type]: true, }));
          const request :RequestChatBotProjectSecret = {
            domain: userProject.project.domain,
            project_id:userProject.project.id??"",
            integration_id: vIntegration.id??""
          }
          const response = await chatbotProjectSecret(request,user, setUser);   
          if(response.success && response.code == 200){
            const intResp = response.data as iProIntegration;
            const updatedIntegrations = clonedIntegrationsAlt.map((integration) =>
              {
                if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Whatsapp){
                  return{ ...integration, 
                    account_id: intResp.account_id,
                    graph_api_token: intResp.graph_api_token,
                  }
                } 
                if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Azure_bot){
                  return{ ...integration,  
                    account_id: intResp.account_id,
                    app_id: intResp.app_id,
                    secret: intResp.secret,
                    app_tenantid: intResp.app_tenantid
                  }
                } 
                if(integration.type === vIntegration.type && vIntegration.type == IntegrationType.Supplier){
                  return{ ...integration,  
                    account_id: intResp.account_id,
                  }
                } 
                return integration 
              } 
            );
          setClonedIntegrationsAlt(updatedIntegrations); 
          toggleVisibility(vIntegration.type);
          }else {
            addAlert("Datos no encontrados",AlertType.Warning);
          } 
        } catch (error) { 
          addAlert("Datos no encontrados",AlertType.Error); 
        } finally {         
          setLoadingVisibility((prev) => ({ ...prev, [vIntegration.type]: false, })); 
        } 
    }else{
        toggleVisibility(vIntegration.type);
      } 
  };
  // Embed integration
  const [isModalWidgetOpen, setIsModalWidgetOpen] = useState(false);  
  const handleWidgetChange = (newConfig: iWidgetChatConfig) => {
    setUserProject((prevProject: iProProjectMain | null) => {
      if (!prevProject?.project?.chpro_integrations) return prevProject;
      const embedIndex = prevProject.project.chpro_integrations.findIndex(
        (integration) => integration.type === IntegrationType.Embed
      ); 
      if (embedIndex === -1) { return prevProject;}  
      const updated = structuredClone(prevProject);
      updated.project.chpro_integrations[embedIndex].props = newConfig; 
      updated.project.chpro_integrations[embedIndex].edit = true; 
      return updated;
    });
    setIsModalWidgetOpen(false);
  };
  const embedIntegration = integrations.find( (intg) => intg.type === IntegrationType.Embed );



  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-4">Integraciones</h2>
      {integrations.map((integration:iProIntegration, index) => (
        <div key={integration.type} className="flex flex-col border p-4 mb-4 rounded-lg shadow-md">
          <div className="flex items-center justify-between gap-4"> 
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={integration.active}
                  onChange={() => handleToggleActive(integration)}
                  className="h-4 w-4 text-blue-600 rounded flex-shrink-0 focus:ring-1 focus:ring-blue-700" 
                />
                {getIntegrationType(integration.type)}
              </label>
              {integration.id&& integration.type!= IntegrationType.Embed &&( 
                <div className="flex items-center gap-2 ml-auto">
                  {loadingVisibility[integration.type]?<Loading w="w-2" h="h-2" className=" pl-2 pr-2"/>:
                    <button 
                      type="button"
                      onClick={() => fetchToggleViev(integration)}
                      className={`flex items-center ${!integration.active || integration.edit ?"bg-zinc-100": "btn-inca-secondary" } justify-center px-2 py-2 rounded-full transition-colors border shadow-md`}
                      disabled={!integration.active||integration.edit||loadingVisibility[integration.type]}
                    >  
                    
                      {visibility[integration.type]?
                        <EyeOff className="w-4 h-4 animate-fade-in" strokeWidth={1.5} />:
                        <Eye className="w-4 h-4 animate-fade-in" strokeWidth={1.5} />
                      }
                    </button>
                    } 
                    <button 
                      type="button"
                      onClick={() => handleToggleEdit(integration)}
                      className={`flex items-center ${!integration.active?"bg-zinc-100": "btn-inca-secondary" } justify-center px-2 py-2 rounded-full transition-colors border shadow-md`}
                      disabled={!integration.active}
                    >  
                      {integration.edit?
                        <Undo2 className="w-4 h-4 animate-fade-in" strokeWidth={1.5} />:
                        <Pencil className="w-4 h-4 animate-fade-in" strokeWidth={1.5} />
                      } 
                    </button>  
                </div>
              )}

              {integration.type== IntegrationType.Embed &&integration.active &&( 
                <div className="flex items-center gap-2 ml-auto"> 
                  <label className="block text-base font-medium  px-2 ">Personalizar botón: </label>
                  <button
                    type="button"
                    className="flex items-center justify-center px-3 py-3 rounded-full btn-inca-secondary shadow-md"
                    onClick={()=>{setIsModalWidgetOpen(true) }}
                  >
                    <Palette />
                  </button>
                  <Modal isOpen={isModalWidgetOpen} onClose={()=>{setIsModalWidgetOpen(false) }}>
                    <ChatWidgetEditor
                        configStart={(embedIntegration?.props)?(embedIntegration?.props):getDefaultWidgetChatConfig()}
                        onChange={(newConfig) => handleWidgetChange(newConfig)}
                        onClose={()=>{setIsModalWidgetOpen(false) }}
                    />
                    
                  </Modal>
                </div>

              )} 

            </div>

          {integration.active && integration.type != IntegrationType.Embed &&(
            <div className="mt-4 space-y-2"> 
                <label className="block text-sm font-medium">Cuenta</label>
                {integration.edit?
                  <input
                  type={integration.edit ? "text" : "password"}
                  placeholder="Account ID"
                  value={integration.account_id}
                  onChange={(e) => handleInputChange(integration, "account_id", e.target.value)}
                  disabled={!integration.edit}
                  className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
                /> 
                :
                <div className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100" >
                  { visibility[integration.type]?
                        clonedIntegrationsAlt.find(O => O.type == integration.type)?.account_id ?? "":
                        maskText(integration.account_id??"")}&nbsp;
                </div>
                } 

              {integration.type === IntegrationType.Whatsapp && (
                <>
                  <label className="block text-sm font-medium">Graph API Token</label>
                  {integration.edit?
                    <input
                      type={integration.edit ? "text" : "password"}
                      placeholder="Graph API Token"
                      value={integration.graph_api_token || ""}
                      onChange={(e) => handleInputChange(integration, "graph_api_token", e.target.value)}
                      disabled={!integration.edit}
                      className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
                    />
                    :
                    <div className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100" >
                      {visibility[integration.type]?
                        clonedIntegrationsAlt.find(O => O.type == integration.type)?.graph_api_token ?? "":
                        maskText(integration.graph_api_token??"")}&nbsp;
                    </div>
                  }
                </>
              )}

              {integration.type === IntegrationType.Azure_bot && (
                <>
                  <label className="block text-sm font-medium">App ID</label>
                  {integration.edit?
                    <input
                      type={integration.edit ? "text" : "password"}
                      placeholder="App ID"
                      value={integration.app_id || ""}
                      onChange={(e) => handleInputChange(integration, "app_id", e.target.value)}
                      disabled={!integration.edit}
                      className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
                    />
                    :
                    <div className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100" >
                      {visibility[integration.type]?
                        clonedIntegrationsAlt.find(O => O.type == integration.type)?.app_id ?? "":
                        maskText(integration.app_id??"")}&nbsp;
                    </div>
                  }
 
                  <label className="block text-sm font-medium">Secret</label>
                  {integration.edit? 
                    <input
                      type={integration.edit ? "text" : "password"}
                      placeholder="Secret"
                      value={integration.secret} 
                      onChange={(e) => handleInputChange(integration, "secret", e.target.value)}
                      disabled={!integration.edit}
                      className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
                    />
                    :
                    <div className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100" >
                      {visibility[integration.type]?
                        clonedIntegrationsAlt.find(O => O.type == integration.type)?.secret ?? "":
                        maskText(integration.secret??"")}&nbsp;
                    </div>
                  }
                  
                  <label className="block text-sm font-medium">Tipo aplicación</label>
                  <div className="relative">
                    <select
                      value={integration.app_type || ""}
                      onChange={(e) =>
                        handleInputChange(integration, "app_type", e.target.value)
                      }
                      disabled={!integration.edit}
                      className="appearance-none w-full border n-fmr-input my-2 px-4 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 leading-tight"
                    >
                      <option value="" disabled>Seleccione un tipo</option>
                      {appTypes.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.text}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="w-5 h-5 absolute top-1/2 right-3 -translate-y-1/2 pointer-events-none text-gray-400" />

                  </div>
                    
                  <label className="block text-sm font-medium">ID Inquilino(Tenant ID)</label>
                  {integration.edit?
                    <input
                      type="text"
                      placeholder="ID Inquilino(Tenant ID)"
                      value={integration.app_tenantid || ""}
                      onChange={(e) => handleInputChange(integration, "app_tenantid", e.target.value)}
                      disabled={!integration.edit}
                      className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
                    />
                    :
                    <div className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100" >
                      {visibility[integration.type]?
                        clonedIntegrationsAlt.find(O => O.type == integration.type)?.app_tenantid ?? "":
                        maskText(integration.app_tenantid??"")}&nbsp;
                    </div>
                  }
                </>
              )}
               
            </div>
          )}
          {integration.active && integration.type === IntegrationType.Embed && (
            <>
              <label className="block text-sm font-medium">Con inicio de sesión</label>
              <div className="flex items-center gap-2 my-2">
              <input
                type="text"
                value={`<script src="${process.env.NEXT_PUBLIC_CHATBOT_EMBED_HOST}/itc_hub_ia.js?key=${integration.key}" async ></script>`}
                readOnly
                className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100"
              />
              <button
                type="button"
                className="flex items-center justify-center px-4 py-4 rounded-full btn-inca-secondary shadow-md"
                title="Copiar"
                onClick={() =>
                  handleCopy(
                    `<script src="${process.env.NEXT_PUBLIC_CHATBOT_EMBED_HOST}/itc_hub_ia.js?key=${integration.key}" async ></script>`
                  )
                }
              >
                <Copy size={18} />
              </button>

              </div>
              <label className="block text-sm font-medium">Modo incógnito</label>
              <div className="flex items-center gap-2 my-2">
              <input
                type="text"
                value={`<script src="${process.env.NEXT_PUBLIC_CHATBOT_EMBED_HOST}/itc_hub_ia.js?key=${integration.key}&incognito=true" async ></script>`}
                readOnly
                className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700 bg-zinc-100"
              />
                <button
                type="button"
                className="flex items-center justify-center px-4 py-4 rounded-full btn-inca-secondary shadow-md"
                onClick={() =>
                  handleCopy(
                    `<script src="${process.env.NEXT_PUBLIC_CHATBOT_EMBED_HOST}/itc_hub_ia.js?key=${integration.key}&incognito=true" async ></script>`
                  )
                }
              >
                <Copy size={18} />
              </button>
              </div>

              <label className="block text-sm font-medium mt-4">Dominios permitidos</label>

              <div className="flex items-center gap-2 my-2">
                <input
                  type="text"
                  placeholder="Agregar dominio"
                  className="w-full border n-fmr-input px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleAddDomain(integration, e.currentTarget.value);
                      e.currentTarget.value = "";
                    }
                  }}
                />
                <button
                  type="button"
                  className="flex items-center justify-center px-4 py-4 rounded-full btn-inca-secondary shadow-md"
                  onClick={(e) => {
                    const input = (e.currentTarget.previousSibling as HTMLInputElement);
                    handleAddDomain(integration, input.value);
                    input.value = "";
                  }}
                >
                  <Plus size={18} strokeWidth={1.5} />
                </button>
              </div>

              <div className="space-y-2">
                {(integration.domains || []).map((domain, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-full border n-fmr-input px-3 py-2 border-gray-300 bg-zinc-100">
                      {domain}
                    </div>
                    <button
                      type="button"
                      onClick={() => handleRemoveDomain(integration, idx)}
                      className="flex items-center justify-center px-2 py-2 rounded-full bg-red-500 text-white shadow-md"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
              
              

                 


            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default IntegrationForm;
